import { render, staticRenderFns } from "./edituser.vue?vue&type=template&id=641aff83&scoped=true"
import script from "./edituser.js?vue&type=script&lang=js&external"
export * from "./edituser.js?vue&type=script&lang=js&external"
import style0 from "./edituser.vue?vue&type=style&index=0&id=641aff83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641aff83",
  null
  
)

export default component.exports